export const STATUS_LABEL: Record<string, string> = {
  pending: "Aguardando",
  in_progress: "Em andamento",
  completed: "Concluída",
  expired: "Expirada",
};

export const STATUS_CLASS: Record<string, string> = {
  pending: "bg-yellow-50 text-yellow-700 border-yellow-200",
  in_progress: "bg-blue-50 text-blue-700 border-blue-200",
  completed: "bg-emerald-50 text-emerald-700 border-emerald-200",
  expired: "bg-muted text-muted-foreground border-border",
};
